import Main from '@/components/main'
// import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/registor',
    name: 'registor',
    meta: {
      title: 'Registor - 注册',
      hideInMenu: true
    },
    component: () => import('@/view/registor/registor.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: Main,
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    children: [
      {
        path: 'message_page',
        name: 'message_page',
        meta: {
          icon: 'md-notifications',
          title: '消息中心'
        },
        component: () => import('@/view/single-page/message/index.vue')
      }
    ]
  },
  {
    path: '/article',
    name: 'article',
    meta: {
      icon: 'logo-buffer',
      title: '文章'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: 'article_list_page',
        meta: {
          icon: 'md-grid',
          title: '文章列表'
        },
        component: () => import('@/view/article/list.vue')
      },
      {
        path: '/article/edit/:id',
        name: 'article_edit_page',
        meta: {
          hideInMenu: true,
          hideInBread: false,
          icon: 'md-create',
          title: '文章编辑',
          notCache: true
        },
        component: () => import('@/view/article/edit.vue')
      },
      {
        path: 'new',
        name: 'article_new',
        meta: {
          icon: 'logo-markdown',
          title: '新建文章'
        },
        component: () => import('@/view/article/new.vue')
      }
    ]
  },
  {
    path: '/machine',
    name: 'machine_manage',
    meta: {
      access: ['admin'],
      icon: 'md-cloud-upload',
      title: '机器管理'
    },
    component: Main,
    children: [
      {
        path: 'machines',
        name: '机器',
        meta: {
          icon: 'md-desktop',
          title: 'Machines'
        },
        component: () => import('@/view/agent/agent.vue')
      },
      {
        path: 'xterm',
        name: 'xterm',
        meta: {
          icon: 'md-clipboard',
          title: 'XTerm',
          hideInBread: false,
          hideInMenu: true
        },
        component: () => import('@/view/xterm/xterm.vue')
      }
    ]
  },
  {
    path: '/explorer',
    name: 'explorer',
    meta: {
      icon: 'md-folder',
      title: '文件管理'
    },
    component: Main,
    children: [
      {
        path: 'picture',
        name: 'picture_manage',
        meta: {
          icon: 'ios-document',
          title: '图片管理'
        },
        component: () => import('@/view/file-explorer/album.vue')
      },
      {
        path: 'detail/:id',
        name: 'file_detail',
        meta: {
          icon: 'ios-document',
          title: '文件详情',
          hideInMenu: true,
          notCache: true
        },
        component: () => import('@/view/file-explorer/detail.vue')
      },
      {
        path: 'file',
        name: 'file',
        meta: {
          icon: 'md-clipboard',
          title: '文件浏览'
        },
        component: () => import('@/view/file-explorer/list.vue')
      }
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      access: ['admin'],
      icon: 'md-settings',
      title: '系统设置'
    },
    component: Main,
    children: [
      {
        path: 'site_manage',
        name: 'site_manage',
        meta: {
          icon: 'md-globe',
          title: '静态站管理'
        },
        component: () => import('@/view/system/static-site-manage.vue')
      },
      {
        path: 'oss_manage',
        name: 'oss_manage',
        meta: {
          icon: 'md-globe',
          title: '存储管理'
        },
        component: () => import('@/view/system/oss.vue')
      }
    ]
  },
  {
    path: '/user',
    name: 'user_manage',
    meta: {
      access: ['admin'],
      icon: 'md-settings',
      title: '用户管理'
    },
    component: Main,
    children: [
      {
        path: 'register',
        name: 'register',
        meta: {
          icon: 'md-globe',
          title: '注册'
        },
        component: () => import('@/view/user/register.vue')
      },
      {
        path: 'history',
        name: 'login_history',
        meta: {
          icon: 'md-globe',
          title: '登陆历史'
        },
        component: () => import('@/view/user/history.vue')
      },
      {
        path: 'resetpwd',
        name: 'reset_password',
        meta: {
          icon: 'md-globe',
          title: '重置密码'
        },
        component: () => import('@/view/user/reset.vue')
      },
      {
        path: 'chpwd',
        name: 'modify_password',
        meta: {
          icon: 'md-globe',
          title: '修改密码'
        },
        component: () => import('@/view/user/change-password.vue')
      }
    ]
  },
  {
    path: '/error_logger',
    name: 'error_logger',
    meta: {
      hideInBread: true,
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'error_logger_page',
        name: 'error_logger_page',
        meta: {
          icon: 'ios-bug',
          title: '错误收集'
        },
        component: () => import('@/view/single-page/error-logger.vue')
      }
    ]
  },
  {
    path: '/argu',
    name: 'argu',
    meta: {
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'params/:id',
        name: 'params',
        meta: {
          icon: 'md-flower',
          title: route => `{{ params }}-${route.params.id}`,
          notCache: true,
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/view/argu-page/params.vue')
      },
      {
        path: 'query',
        name: 'query',
        meta: {
          icon: 'md-flower',
          title: route => `{{ query }}-${route.query.id}`,
          notCache: true
        },
        component: () => import('@/view/argu-page/query.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
